// extracted by mini-css-extract-plugin
export default {"item":"Summary_item__NlA8B","meta":"Summary_meta__DrX48","outdatedValue":"Summary_outdatedValue__0mHMi","devided":"Summary_devided__VuwzY"};